import { DateTime } from "luxon"
import { MonetaryAmount } from "../../../currency/currencyTypes"
import { DeliveryType, DetailsOrderType } from "../production/meetingService/meetingServiceTypes"
import { DeviceType } from "../../../entities/devices/deviceTypes"

export type SalesSummary = Readonly<{
    numberOfOrders: number
    totalAmount: MonetaryAmount
}>

export type ShopSalesSummary = SalesSummary &
    Readonly<{
        id: number
        name: string
    }>

export type CheckinSummary = Readonly<{
    numberOfOrders: number
    numberOfCheckIns: number
    noCheckInsPercentage: number
    checkInsPercentage: number
}>

export type AverageAmount = Readonly<{
    data: string
    salesSummary: {
        totalAmount: MonetaryAmount
    }
}>

export type SubscriptionsSale = Readonly<{
    data: string
    salesSummary: {
        numberOfSubscriptions: number
    }
}>

// Meeting service
export enum OrderStatusType {
    READY_FOR_INVOICE = "READY_FOR_INVOICE",
    AWAITING_APPROVAL = "AWAITING_APPROVAL",
}

export type ReportDetailsType = Readonly<{
    orderStatus: OrderStatusType
    orderType: DetailsOrderType
    overdueDays?: number
    reportTime: DateTime
}>

export type MeetingServiceSale = Readonly<{
    date: string
    salesSummary: ReportSummaryType
}>

export type ReportSummaryType = Readonly<{
    numberOfOrders: number
    totalAmount?: MonetaryAmount
}>

export type ReportDetailsPerHour = Readonly<{
    startDate: string
    endDate: string
    reportTime: DateTime
}>

export type MeetingServiceSaleDetail = Readonly<{
    salesPerHour: {
        period: {
            from: {
                time: string
            }
            to: {
                time: string
            }
        }
        deliveryTypes: {
            name: DeliveryType
            salesSummary: {
                numberOfOrders: number
            }
        }[]
    }[]
}>

export enum DeviceTypeReportStatus {
    ALERT = "ALERT",
    WARNING = "WARNING",
    INFO = "INFO",
    SUCCESS = "SUCCESS",
}
export type DeviceReportBase = Readonly<{
    title: string
    message: string
    state: DeviceTypeReportStatus
}>
export type DeviceTypeReport = Readonly<{
    id: number
    name: string
    type: DeviceType
    status: {
        state: DeviceTypeReportStatus
        message: string
    }
}>

export type DeviceReportResponse = Readonly<{
    deviceReport?: DeviceReportBase
    devices: DeviceTypeReport[]
}>

export type ReportSummaryPos = Readonly<{
    changeInPercentage: number
    totalAmount: MonetaryAmount
}>

export type SalesSummaryPos = Readonly<{
    date: string
    salesSummary: { totalAmount: MonetaryAmount }
}>

export type ReportSummaryNumberOfTransactions = Readonly<{
    changeInPercentage: number
    numberOfOrders: number
}>
export type PosSaleNumberOfTransactions = Readonly<{
    date: string
    salesSummary: { numberOfOrders: number }
}>

export type ReportSummaryNumberOfUsers = Readonly<{
    numberOfUsers: number
    changeInPercentage: number
}>

export type NumberOfUsers = Readonly<{
    date: string
    number: number
}>
